/**
 * TradeFinder panel tabs, as a registry: the panel renders whatever is in
 * TRADEFINDER_TABS, in order, so a new tab is one entry here and nothing
 * else changes.
 *
 * Append new tabs at the end; do not stub planned ones.
 */
import React from 'react';
import SignalsTab from './SignalsTab';
import StatusTab from './StatusTab';
import LinesTab from './LinesTab';
import SettingsTab, { SettingsUnsavedBadge } from './SettingsTab';

export interface TradeFinderTabProps {
  /** The chart's symbol (watcher key, e.g. MNQZ6.CME). */
  symbol: string;
  /** Centre the chart on this time (ms); absent when the chart cannot. */
  onJumpTo?: (timestampMs: number) => void;
}

export interface TradeFinderTab {
  /** Stable id: testids are `tradefinder-tab-<id>`. */
  id: string;
  label: string;
  Component: React.ComponentType<TradeFinderTabProps>;
  /** Optional marker after the label (e.g. unsaved changes); renders nothing when idle. */
  Badge?: React.ComponentType;
}

export const TRADEFINDER_TABS: TradeFinderTab[] = [
  { id: 'signals', label: 'Signals', Component: SignalsTab },
  { id: 'status', label: 'Status', Component: StatusTab },
  { id: 'lines', label: 'Lines', Component: LinesTab },
  { id: 'settings', label: 'Settings', Component: SettingsTab, Badge: SettingsUnsavedBadge },
];
